import type { Ref } from 'vue';
import { watch } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';

export default class WebinarRegistrationProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): void {
    if (!formDefinition.value) {
      return;
    }
    super.realtimeBranchModifications({ formDefinition });

    const cadExperienceField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.whatIsYourExperience,
    });
    cadExperienceField.componentName = 'hidden-field';
    const formVariantFieldVal = ExternalUtil.findDisplayFieldValOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.formVariant,
    });

    watch(formVariantFieldVal, (newVal) => {
      if (newVal === 'QualifyingQuestion') {
        cadExperienceField.componentName = 'single-select-field';
      }
    });
  }
}
